import types from './types';
import TimeUtils from '@/utils/TimeUtils'

export default {
  [types.getters.GET_BOOKING]: (state) => (dateString, bookingId) => {
    const weekId = TimeUtils.dateToWeek(dateString);
    const week = state.weeks[weekId] || { bookings: [] }
    const booking = week.bookings.find((b) => {
      return b.id === Number(bookingId)
    })
    return booking;
  },
  [types.getters.GET_BOOKINGS_BY_ROOM]: (state) => (dateString, roomId) => {
    // console.log('getBookingsByRoom date', dateString);
    // console.log('getBookingsByRoom roomId', roomId);
    let bookings;
    const weekString = TimeUtils.dateToWeek(dateString);
    // console.log('getBookingsByRoom weekString', weekString);
    const week = state.weeks[weekString];
    if (week && week.bookings) {
      bookings = week.bookings.filter(b => Number(b.roomId) === Number(roomId))
      // console.log('getBookingsByRoom bookings', bookings);
      bookings = bookings.filter(b => b.date === dateString);
      // console.log('getBookingsByRoom bookings', bookings);
    }
    // console.log('all', state.weeks);

    return bookings;
  },
  [types.getters.GET_DAY_BY_ROOM]: (state, getters) => (dateString, roomId) => {
    console.log('GET_DAY');
    const all = getters[types.getters.GET_BOOKINGS_BY_ROOM](dateString, roomId)
    if (all) {
      return all.filter(b => b.date === dateString);
    } else {
      return undefined;
    }
  },
  [types.getters.GET_WEEK]: (state) => (date) => {
    const weekId = TimeUtils.dateToWeek(date);
    const week = state.weeks[weekId];
    console.group('GET_WEEK');
    console.dir(date);
    console.dir(weekId);
    console.groupEnd('GET_WEEK');
    return week;
  },
  [types.getters.HAS_WEEK]: (state) => (date) => {
    const weekId = TimeUtils.dateToWeek(date);
    console.group('HAS_WEEK');
    console.dir(date);
    console.dir(weekId);
    console.dir(state.weeks[weekId]);
    console.groupEnd('HAS_WEEK');
    return !!state.weeks[weekId];
  },
  [types.getters.IS_FETCHING]: (state) => () => {
    return state.fetch.status === 'pending'
  },
  [types.getters.GET_CREATE_STATUS]: (state) => () => {
    return state.create.status;
  },
  [types.getters.GET_EDIT_STATUS]: (state) => () => {
    return state.edit.status;
  },
  [types.getters.GET_DELETE_STATUS]: (state) => () => {
    return state.delete.status;
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/booking/getters.js